const normalizeBasePath = (basePath: string) => {
  if (!basePath) {
    return "";
  }

  const trimmedBasePath = basePath.trim().replace(/\/+$/, "");

  if (/^https?:\/\//i.test(trimmedBasePath)) {
    return trimmedBasePath;
  }

  return `http://${trimmedBasePath}`;
};

export const API_BASE_PATH = normalizeBasePath(process.env.BACKEND_BASE_URL || "");

export default normalizeBasePath;
